module.exports = __webpack_public_path__ + "img/defiled_granary_small.13ebf8f7.png";